import React from 'react';
import classNames from 'classnames';
import MapContainer from '@/components/Map/MapContainer';
import { ImageType } from '@/utils/common.types';

interface Props {
  paragraphStyle: string;
  officeLocations: {
    __typename: string;
    officeName: string;
    officeLocationType: string[];
    officeMap: {
      lat: number;
      lon: number;
    };
    officeCityState: string;
    officeButtons: {
      primary: {
        label: string;
        url: string;
        isRelative: boolean;
        isOpenNewWindow: boolean;
      };
    };
    officeLogo?: {
      svg: ImageType;
    };
  }[];
  mapStyle: string;
}

const CtaCardMap = ({ paragraphStyle, officeLocations, mapStyle }: Props) => {
  return (
    <div>
      <div
        className={classNames({
          ['text-left']: paragraphStyle && paragraphStyle === 'left',
          ['text-center']: paragraphStyle && paragraphStyle !== 'left',
        })}
      >
        {officeLocations && (
          <MapContainer locations={officeLocations} mapStyle={mapStyle} />
        )}
      </div>
    </div>
  );
};

export default CtaCardMap;
